import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';

import dashboard from './Dashboard/reducer';
import categories from './Categories/reducer';
import modifiers from './Modifiers/reducer';
import dish from './Dish/reducer';
import inventory from './Inventory/reducer';
import orders from './Orders/reducer';
import app from './App/reducer';
import settings from './Settings/reducer';
import restaurant from './Restaurant/reducer';
import menu from './Menu/reducer';

export default (history) => combineReducers({
    router: connectRouter(history),
    dashboard,
    categories,
    modifiers,
    dish,
    inventory,
    orders,
    app,
    settings,
    restaurant,
    menu
});
